import React, { useState } from "react";

function Extramaterial({
  currentMaterial,
  materials,
  setCurrentMaterial,
  setMaterials,
  apiMaterials,
}) {
  const [showForm, setShowForm] = useState(false);
  let user = localStorage.getItem("userName");

  const materialPriceRanges = apiMaterials.reduce((acc, material) => {
    acc[material.material_code] = {
      min: material.min_price,
      max: material.max_price,
    };
    return acc;
  }, {});
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setCurrentMaterial((prevMaterial) => {
      if (id === "materialType") {
        // Get the min and max values based on the selected material type
        const { min, max } = materialPriceRanges[value] || { min: 0, max: 0 };

        // Check if the material type is 'l_stand_p' and set the price to min
        const price = value === "l_stand_p" ? min : max;

        return {
          ...prevMaterial,
          materialType: value,
          quantity: "1",
          price: price, // Use min value for l_stand_p, max for others
          totalAmount: price, // Set totalAmount based on the price
        };
      }

      const updatedMaterial = {
        ...prevMaterial,
        [id]: value,
      };

      if (id === "quantity" || id === "price") {
        updatedMaterial.totalAmount =
          (updatedMaterial.quantity || 1) * (updatedMaterial.price || 0);
      }

      return updatedMaterial;
    });
  };

  const handlePriceBlur = () => {
    const { materialType, price } = currentMaterial;
    const priceValue = parseFloat(price);
    if (materialType && priceValue) {
      const { min } = materialPriceRanges[materialType] || { min: 0 };
      if (user === "Sales Admin" || user === "Gajanan Padhar" || user === "Vineet Vidyanand") {
        return;
      }
      if (user === "Karishma") {
        if (
          materialType === "copper_piping_p" ||
          materialType === "copper_piping_cassette_p"
        ) {
          if (priceValue < 300) {
            alert(`Price for ${materialType} should not be less than 300`);
            setCurrentMaterial((prevMaterial) => ({
              ...prevMaterial,
              price: 300,
            }));
          }
        }
      } else {
        if (priceValue < min) {
          alert(`Price for ${materialType} should not be less than ${min}`);
          setCurrentMaterial((prevMaterial) => ({
            ...prevMaterial,
            price: min,
          }));
        }
      }
    }
  };

  const addMaterial = () => {
    const totalAmount = currentMaterial.quantity * currentMaterial.price;

    if (
      !currentMaterial.materialType ||
      !currentMaterial.quantity ||
      !currentMaterial.price
    ) {
      alert("Please fill in all fields");
      return;
    }

    setMaterials((prevMaterials) => [
      ...prevMaterials,
      { ...currentMaterial, totalAmount },
    ]);

    setCurrentMaterial({
      materialType: "",
      quantity: "",
      price: "",
      totalAmount: "",
    });
    setShowForm(false);
  };

  const handleRemove = (index) => {
    setMaterials((prevMaterials) =>
      prevMaterials.filter((_, i) => i !== index)
    );
  };
  const isFeetMaterial =
    currentMaterial.materialType === "copper_piping_p" ||
    currentMaterial.materialType === "copper_piping_cassette_p" ||
    currentMaterial.materialType === "drain_pipe" ||
    currentMaterial.materialType === "core_cable_4_p";

  const materialTypeMapping = apiMaterials.reduce((acc, material) => {
    acc[material.material_code] = material.material_name;
    return acc;
  }, {});
  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
      <h1 className="font-semibold text-lg">Extra Materials</h1>

      {materials.length > 0 && (
        <div className="mt-6">
          <div className="flex flex-wrap gap-4">
            {materials.map((item, index) => {
              const isFeet = [
                "copper_piping_p",
                "copper_piping_cassette_p",
                "drain_pipe",
                "core_cable_4_p",
              ].includes(item.materialType);

              return (
                <div
                  key={index}
                  className="border border-primary p-4 rounded-2xl"
                >
                  <p>
                    {materialTypeMapping[item.materialType] ||
                      "Unknown Material"}
                  </p>
                  <p>
                    Quantity: {item.quantity} {isFeet ? "feet" : ""}
                  </p>
                  <p>Price: {item.price}</p>
                  <p>Total Amount: {item.totalAmount}</p>
                  <button
                    onClick={() => handleRemove(index)}
                    className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
                  >
                    Remove
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="mt-4 bg-primary text-white font-normal py-2 px-4 rounded"
        >
          + Add Material
        </button>
      )}

      {showForm && (
        <div className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <div>
              <label
                htmlFor="materialType"
                className="block font-semibold mb-2"
              >
                Materials type:
              </label>
              <select
                id="materialType"
                value={currentMaterial.materialType}
                onChange={handleInputChange}
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
              >
                <option value="">Select a material</option>
                {apiMaterials && apiMaterials.length > 0 ? (
                  apiMaterials.map((material) => (
                    <option
                      key={material.material_code}
                      value={material.material_code}
                    >
                      {material.material_name}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading materials...</option>
                )}
              </select>
            </div>

            <div>
              <label htmlFor="quantity" className="block font-semibold mb-2">
                Quantity{isFeetMaterial ? " (feet)" : ""}:
              </label>
              <input
                id="quantity"
                type="number"
                value={currentMaterial.quantity}
                onChange={handleInputChange}
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                required
              />
            </div>

            <div>
              <label htmlFor="price" className="block font-semibold mb-2">
                Price:
              </label>
              <input
                id="price"
                type="text"
                value={currentMaterial.price}
                onChange={handleInputChange}
                onBlur={handlePriceBlur}
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                required
              />
            </div>

            <div>
              <label htmlFor="totalAmount" className="block font-semibold mb-2">
                Total amount:
              </label>
              <input
                type="text"
                value={currentMaterial.quantity * currentMaterial.price}
                disabled
                className="w-full border-2 border-gray-300 rounded py-2 px-4 bg-gray-100"
              />
            </div>
          </div>

          <button
            onClick={addMaterial}
            className="mt-4 bg-primary text-white font-normal py-2 px-4 rounded"
          >
            Save Material Details
          </button>
        </div>
      )}
    </div>
  );
}

export default Extramaterial;
